///////////////////////////////////////
/*       20220421 Created by lyj      */
///////////////////////////////////////

import { isUseAPI } from '@/utils/check';
import request from '@/utils/request';
import getRiskOrgnManageMasterData from '../baseManage/mock/RiskOrgnManageMaster.json'; // restful api를 사용하지 않을 경우

// 공통코드 조회
// param : compId, majorCd  ex) getCommonCode()
export function getCommonCode(param, isNotify) {
  let isTest = false
  let params = {
    compId: param.compId,
    majorCd: param.majorCd
  }

  return request({
    url: '/api/getCommonCode',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}
///////////////////////////////////////
/*       컴포넌트                     */
///////////////////////////////////////

//params: comp_id
export function getHumanResourceByRiskAsse(param, isNotify) {
  let isTest = false
  if (!isUseAPI() || isTest) {
    return new Promise(function(resolve, reject) {
      let res = getRiskOrgnManageMasterData
      console.log('api', res)
      resolve(res)
    })
  }
  return request({
    url: '/api/getHumanResourceByRiskAsse',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

///////////////////////////////////////
/*       위험성 조직 정보[마스터]      */
///////////////////////////////////////

// 위험성평가 조직 정보 조회[마스터]
export function getRiskOrgnManageMaster(param, isNotify) {
  let isTest = false
  if (!isUseAPI() || isTest) {
    return new Promise(function(resolve, reject) {
      let res = getRiskOrgnManageMasterData
      console.log('api', res)
      resolve(res)
    })
  }
  return request({
    url: '/api/getRiskOrgnManageMaster',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

// 위험성평가 특정 조직 정보 조회[마스터]
export function getRiskOrgnManageMasterByOrgnOrder(param, isNotify) {
  let isTest = false
  if (!isUseAPI() || isTest) {
    return new Promise(function(resolve, reject) {
      let res = getRiskOrgnManageMasterData
      console.log('api', res)
      resolve(res)
    })
  }
  return request({
    url: '/api/getRiskOrgnManageMasterByOrgnOrder',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

// 위험성 조직 저장
export function saveRiskOrgnManageMaster(param, isNotify) {
  let isTest = true
  if (!isUseAPI() || isTest) {
    console.log()
  }
  return request({
    url: '/api/saveRiskOrgnManageMaster',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}

// 위험성 조직 삭제
export function deleteRiskOrgnManageMaster(param, isNotify) {
  let isTest = true
  if (!isUseAPI() || isTest) {
    console.log()
  }

  return request({
    url: '/api/deleteRiskOrgnManageMaster',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

///////////////////////////////////////
/*       위험성 조직 정보[디테일]      */
///////////////////////////////////////
// 위험성평가 조직 정보 조회 [디테일]
export function getRiskOrgnManageDetail(param, isNotify) {
  let isTest = false
  // if (!isUseAPI() || isTest) {
  //   return new Promise(function(resolve, reject) {
  //     let res = getRiskOrgnManageDetailData
  //     console.log('api', res)
  //     resolve(res)
  //   })
  // }
  return request({
    url: '/api/getRiskOrgnManageDetail',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

// 위험성 조직 구성도 저장[디테일]
export function saveRiskOrgnManageDetail(param, isNotify) {
  let isTest = true
  if (!isUseAPI() || isTest) {
    console.log()
  }
  return request({
    url: '/api/saveRiskOrgnManageDetail',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}

// 위험성 조직 구성도 저장[삭제]
export function deleteRiskOrgnManageDetail(param, isNotify) {
  let isTest = true
  if (!isUseAPI() || isTest) {
    console.log()
  }
  return request({
    url: '/api/deleteRiskOrgnManageDetail',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}


// 위험성평가 조직 정보 조회[마스터]
export function getRiskGrpAuth(isNotify) {
  return request({
    url: '/api/getRiskGrpAuth',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

// 위험성평가 조직 유효성 검사
export function checkRiskOrgn(param, isNotify) {
  return request({
    url: '/api/checkRiskOrgn',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

// 위험성평가 조직 복사 유효성 검사
export function checkCopyRiskOrgnManage(param, isNotify) {
  return request({
    url: '/api/checkCopyRiskOrgnManage',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

// 위험성평가 조직 복사 유효성 검사
export function copyRiskOrgnManage(param, isNotify) {
  return request({
    url: '/api/copyRiskOrgnManage',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}